import { usePOPricingUpdate } from "./usePOPricingUpdate";
import secondaryComponents from "../..";
import styles from "./styles.module.scss";
import primaryComponents from "../../../primaryComponents";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";

export const POPricingUpdate = ({
  PODetails = {},
  POItems = [],
  pricingTypes = [],
  closeModal = () => {},
}) => {
  const { instance, isUpdatingPO, handleUpdatePOSellingPrice } =
    usePOPricingUpdate({
      POItems,
      PODetails,
      pricingTypes,
      closeModal,
    });
  const { getTableBodyProps, getTableProps, headerGroups, rows, prepareRow } =
    instance;

  return (
    <>
      <form id="updatePOPricingForm">
        <secondaryComponents.TableHelper
          getTableBodyProps={getTableBodyProps}
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          rows={rows}
          prepareRow={prepareRow}
          classNames={styles.pOItemsTable}
        >
          <div className="pt-5 text-center">
            <h4>You have no Purchase Order</h4>
            <p>
              Use the button above to place a purchase order . When you do, they
              would appear here.
            </p>
          </div>
        </secondaryComponents.TableHelper>
      </form>

      <div className={`${globalStyles.stickyBottomCover}`}>
        <primaryComponents.Button
          type="button"
          classNames={"btn btn--primary cover"}
          isDisabled={isUpdatingPO}
          isLoading={isUpdatingPO}
          loadingText={"Updating..."}
          onClick={handleUpdatePOSellingPrice}
        >
          Update Selling Price
        </primaryComponents.Button>
      </div>
    </>
  );
};
